<template>
  <div v-if="campaignDetail !== null">
    <referal-popup
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
      :campaignId="campaignDetail.id"
    />
    <header class="w-full">
      <div class="mb-base mt-4 vx-row justify-between items-top">
        <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
          <span class="text-black text-2xl">Tabel Referal</span>
        </section>
        <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
          <vs-button @click="openPopUp(null)">Tambah Referal</vs-button>
        </section>
      </div>
      <div class="vx-row justify-between items-center">
        <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
          <div class="w-full gap-2 flex justify-start items-center">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <vs-button icon-after icon="expand_more">Aksi</vs-button>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="dialogDelete">
                  <span>Hapus</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">{{ `entries ${limit}` }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="(item, index) in limitDataTables"
                  :key="index"
                  @click="limit = item"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </section>
        <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
          <!-- <div class="w-full flex justify-end gap-2 flex-wrap items-center">
            <vs-input v-model="search" placeholder="Search..." />
          </div> -->
        </section>
      </div>

      <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      <div
        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
      ></div>
    </header>

    <main ref="loadReferalCampaign">
      <vs-table stripe :data="referals" v-model="selected" :max-items="limit" multiple>
        <template slot="thead">
          <vs-th>Nama</vs-th>
          <vs-th>Sosmed</vs-th>
          <vs-th>Referal</vs-th>
          <vs-th>Aksi</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].referal ? data[indextr].referal.name : null">
              {{ data[indextr].referal ? data[indextr].referal.name : "(Kosong)" }}
            </vs-td>
            <vs-td :data="data[indextr].referal ? data[indextr].referal.sosmed : null">
              {{ data[indextr].referal ? data[indextr].referal.sosmed : "(Kosong)" }}
            </vs-td>
            <vs-td :data="data[indextr].referal ? data[indextr].referal.referal : null">
              <div
                v-if="data[indextr].campaign !== null"
                class="flex justify-start items-center gap-1"
              >
                <p>
                  {{
                    `${feUser}/campaign/view/${slugGen(
                      data[indextr].campaign.name
                    )}-${encrytId(data[indextr].campaign.id)}/${
                      data[indextr].referal.referal
                    }`
                  }}
                </p>
                <vs-button
                  color="success"
                  type="filled"
                  size="small"
                  v-clipboard:copy="
                    `${feUser}/campaign/view/${slugGen(
                      data[indextr].campaign.name
                    )}-${encrytId(data[indextr].campaign.id)}/${
                      data[indextr].referal.referal
                    }`
                  "
                  icon="file_copy"
                ></vs-button>
              </div>
              <p class="text-danger" v-else>(Campaign Tidak Ada!)</p>
            </vs-td>
            <vs-td>
              <div class="flex justify-start gap-2">
                <vs-tooltip text="Edit">
                  <vs-button
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="openPopUp(data[indextr])"
                  >
                  </vs-button>
                </vs-tooltip>
                <!-- <vs-tooltip text="Submenu">
                    <vs-button
                      color="warning"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-menu"
                      @click="openSubMenu(data[indextr])"
                    >
                    </vs-button>
                  </vs-tooltip> -->
                <vs-tooltip
                  text="Delete"
                  v-if="
                    referalData.find((v) => v.id == data[indextr].referal.id) !==
                    undefined
                  "
                >
                  <vs-button
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="dialogDelete(data[indextr].id, data[indextr].referal.name)"
                  >
                  </vs-button>
                </vs-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </main>
    <footer>
      <div class="justify-end mt-2">
        <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
      </div>
    </footer>
  </div>
</template>

<script>
import ReferalPopup from "@/views/campaign/component/ReferalPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    ReferalPopup,
  },
  props: {
    campaignDetail: { type: Object, default: {} },
  },
  data() {
    return {
      emptyImage,
      url,
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      currentPg: 1,
      params: {},
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      activeSubmenu: false,
      passParent: null,
      passData: null,
      selected: [],
      access: null,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      referals: [],
      search: "",
    };
  },
  computed: {
    feUser() {
      return process.env.VUE_APP_USER;
    },
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    referalData() {
      return this.$store.state.referal.referalList;
    },
    totalPage() {
      let pages = this.$store.state.referal.totalReferal / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  watch: {
    search() {
      if (this.search !== "") {
        this.params = {
          search: this.search,
          filter: "name",
        };
      } else {
        this.params = {};
      }

      this.getData();
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  methods: {
    slugGen(text) {
      return text.replaceAll(" ", "-").toLowerCase();
    },
    encrytId(id) {
      return Buffer.from(id.toString()).toString("base64");
    },
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    callBackSubmenu(val) {
      this.activeSubmenu = val;
      this.passParent = null;
    },
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    openSubMenu(item) {
      this.activeSubmenu = true;
      this.passParent = item;
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                if (
                  this.referalData.find((v) => v.id == this.selected[i].referal.id) !==
                  undefined
                ) {
                  this.delete(this.selected[i].id);
                }
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadReferal,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("referal/cudReferalCampaign", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Referal Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadReferal);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadReferal,
        color: "primary",
      });
      this.$store
        .dispatch("referal/getReferalCampaign", {
          ...this.params,
          ...this.pagination,
          campaign_id: this.campaignDetail.id,
        })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadReferal);
          this.referals = v.data;
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadReferal);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getDataReferal() {
      let profileObj = {};
      if (this.profile.level.id !== 2) {
        profileObj = {
          user_id: this.profile.id,
        };
      }
      this.$store
        .dispatch("referal/getReferal", {
          ...profileObj,
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getData();
    this.getDataReferal();
  },
  created() {
    // if (this.$store.state.auth.profileAccess !== null) {
    //   if (
    //     this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/referal"
    //     )
    //   ) {
    //     this.access = this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/referal"
    //     );
    //   }
    // }
  },
};
</script>

<style scoped>
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
